import { gasApi } from '@/api/gas'
import store from '@/store'

const DEFAULT_LOGO = '/logo.png'
const DEFAULT_COMPANY_NAME = '上海晟颢信息科技有限公司'

export function resolveLogoUrl(configLogo, version) {
  const v = version != null ? version : Date.now()
  if (!configLogo || !String(configLogo).trim()) {
    return DEFAULT_LOGO
  }
  const raw = String(configLogo).trim()
  if (raw.startsWith('data:') || raw.startsWith('http://') || raw.startsWith('https://')) {
    return raw
  }
  const sep = raw.includes('?') ? '&' : '?'
  return `${raw}${sep}v=${v}`
}

/** 从基础设置加载顶栏品牌信息并写入 store */
export async function refreshSiteBranding() {
  try {
    const res = await gasApi.sysConfig.get()
    const d = res.data || {}
    const version = Date.now()
    store.commit('SET_SITE_BRANDING', {
      companyName: d['company.name'] || DEFAULT_COMPANY_NAME,
      configLogoPath: d['company.logo'] || '',
      companyLogo: resolveLogoUrl(d['company.logo'], version),
      logoVersion: version
    })
    if (d['system.name']) {
      document.title = d['system.name']
    }
    return d
  } catch (e) {
    store.commit('SET_SITE_BRANDING', {
      companyName: DEFAULT_COMPANY_NAME,
      companyLogo: DEFAULT_LOGO,
      configLogoPath: '',
      logoVersion: Date.now()
    })
    return null
  }
}
